<template>
  <div>
    <div v-if="!isEdit" class="title is-3">Create a new intro</div>
    <div v-if="isEdit" class="title is-3">Edit this intro</div>

    <form>
      <b-field :message="{ 'Name cannot be blank': errorName }"
               :type="{ 'is-danger': errorName }" horizontal
               label="Name:" style="margin-bottom: 40px">
        <b-input
            v-model="name"
            placeholder="Intro name"
        >
        </b-input>
      </b-field>

      <div v-if="!isTableExists" style="margin: 100px 30px 100px 30px">
        <b-field align="center" horizontal>
          <button class="button is-primary" @click.prevent="createCard">Create new card</button>
        </b-field>
      </div>

      <div v-if="isTableExists">
        <b-field horizontal>
          <b-table
              :data="cards"
              :loading="isLoading"
              :striped="false"
              draggable
              narrowed
              :key="tableKey"
              style="padding-top: 20px"
              @dragleave="dragleave"
              @dragover="dragover"
              @dragstart="dragstart"
              @drop="drop">
            >
            <template slot-scope="props">
              <b-table-column class="centered-table-content" field="index" label="#" width="2%">
                {{ props.index + 1 }}
              </b-table-column>
              <b-table-column class="centered-table-content" field="title" label="Title" width="20%">
                {{ props.row.title }}
              </b-table-column>
              <b-table-column class="centered-table-content" field="body" label="Body" width="24%">
                {{ props.row.body }}
              </b-table-column>
              <b-table-column class="centered-table-content" field="imgUrl" label="Image" width="20%">
                <b-img v-if="isImageValid(props.row.imgUrl)" :height="90" :img="props.row.imgUrl" :width="120"></b-img>
              </b-table-column>
              <b-table-column class="centered-table-content" field="text2" label="Text 2" width="24%">
                {{ props.row.text2 }}
              </b-table-column>
              <b-table-column class="centered-table-content" field="actions" width="10%">
            <span>
              <b-button icon-right="border-color" style="margin: 0 3px 0 3px" @click.prevent="editCard(props.row)"/>
              <b-button icon-right="delete" style="margin: 0 3px 0 3px" type="is-danger"
                        @click.prevent="deleteCard(props.row)"/>
            </span>
              </b-table-column>
            </template>
          </b-table>
        </b-field>
        <b-field align="right" horizontal>
          <button class="button is-primary" style="margin-bottom: 20px" @click.prevent="createCard">Add new card
          </button>
        </b-field>
      </div>

      <div class="control submit">
        <button
            class="button is-light btn-margin"
            @click.prevent="cancel()"
        >
          Back to Intros
        </button>
        <button v-if="!isEdit" :disabled="isActionInvalid" class="button is-primary" @click.prevent="createIntroText">
          Create intro
        </button>
        <button v-if="isEdit" :disabled="isActionInvalid" class="button is-primary" @click.prevent="updateIntroText">
          Update intro
        </button>
      </div>
    </form>
    <b-loading :active.sync="isLoading" :is-full-page="true"></b-loading>
  </div>
</template>

<script>
import displayHelper from '../../helpers/display-helper'
import dateHelper from '../../helpers/date-helper'
import introTextsService from '@/services/introTextsService'
import BImg from '@/components/single/BImg'
import {ModalProgrammatic as Modal} from 'buefy'
import CardForm from '@/components/single/CardForm'
import _ from 'lodash'

export default {
  components: {
    BImg,
  },
  data() {
    return {

      // for update
      isEdit: false,
      introTextLoaded: null,
      introTextId: null,

      //normal
      introTexts: [],
      name: '',
      isLoading: false,
      cards: [],
      isTableExists: false,
      isActionInvalid: true,
      errorName: false,

      draggingRow: null,
      draggingRowIndex: null,

      tableKey: 0
    }
  },
  created() {
    try {
      if (this.$route.params.id) {
        this.isEdit = true
        this.introTextId = this.$route.params.id
        this.isActionInvalid = false
        this.loadIntroTextById(this.introTextId)
      }
    } catch (err) {
      displayHelper.displayError(this, 'Oops, there was an error: ' + err.message)
    }
  },
  methods: {
    loadIntroTextById(introTextId) {
      this.isLoading = true
      var parent = this
      introTextsService.getIntroTextById(introTextId)
          .then((introText) => {
            this.introTextLoaded = introText

            this.name = this.introTextLoaded.name
            this.cards = this.introTextLoaded.cards

            if (this.cards.length > 0) {
              this.isTableExists = true
            }

            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
            this.isLoading = false
          })
    },
    createCard() {
      this.$buefy.modal.open({
        parent: this,
        component: CardForm,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        props: {
          isEdit: false,
        },
        events: {
          'save': card => {
            this.isTableExists = true
            this.isActionInvalid = false
            this.cards.push(card)
          },
        }
      })
    },
    editCard(card) {
      const index = _.findIndex(this.cards, card)

      this.$buefy.modal.open({
        parent: this,
        component: CardForm,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        props: {
          isEdit: true,
          card: card
        },
        events: {
          'save': card => {
            this.cards[index] = card
            this.tableKey++
          },
        }
      })
    },
    deleteCard(card) {
      const index = _.findIndex(this.cards, card)

      this.cards.splice(index, 1)
      if (this.cards.length === 0) {
        this.isTableExists = false
        this.isActionInvalid = true
      }
    },
    async createIntroText() {
      if (!this.name) {
        this.errorName = true
      } else {
        this.isLoading = true
        const introText = {
          name: this.name,
          cards: this.cards,
          createdDate: dateHelper.getFormattedStringDateNow()
        }

        const creationIntroTextResult = await introTextsService.createIntroText(introText)
        this.isLoading = false
        if (creationIntroTextResult.isSuccess) {
          displayHelper.displaySuccess(this, 'Intro has successfully been created')
          this.$router.back()

        } else {
          displayHelper.displayError(this, 'Oops, there was an error: ' + creationPackResult.errors)
        }
      }
    },
    async updateIntroText() {
      this.isLoading = true
      var parent = this
      const introText = {
        introTextId: this.introTextId,
        name: this.name,
        cards: this.cards,
      }

      const updateIntroTextResult = await introTextsService.updateIntroText(introText)
      this.isLoading = false
      if (updateIntroTextResult.isSuccess) {
        displayHelper.displaySuccess(this, 'Intro has successfully been updated')
        this.$router.back()

      } else {
        displayHelper.displayError(parent, 'Oops, there was an error: ' + updatePackResult.errors)
      }
    },
    isImageValid(imageUrl) {
      return imageUrl && imageUrl.startsWith('http')
    },
    cancel() {
      this.$router.go(-1)
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      this.cards.splice(droppedOnRowIndex, 0, this.cards.splice(this.draggingRowIndex, 1)[0])
    }
  }
}
</script>

<style scoped>
.pack-form .is-horizontal .field-label {
  flex-grow: 0;
}

.pack-form label {
  margin-bottom: 0;
  /* width: 50% !important; */
}

.pack-form .column .field {
  align-items: center;
}

.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
